// extracted by mini-css-extract-plugin
export default {"video-link":"g_r d-flex align-items-center my-2","video-link__link":"g_s ml-2"};